// vanalytics only stores a single event_value column, so events with several
// fields pack them as "key=value;key=value" for splitting in BigQuery
export default function packEventValue(fields) {
  return Object.entries(fields)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join(";");
}
